

















import bugsnagClient from '@getaccept/lib-shared/src/bugsnag';
import MarketingModal from '@getaccept/lib-shared/src/marketing-modal/MarketingModal.vue';
import { defineComponent, onBeforeUnmount, onMounted, ref } from '@vue/composition-api';
import { userLanguage } from './helpers/language';
import { loadLanguageAsync } from './i18n/lang';
import LeftImage from './assets/img/carousel-1.svg';

export default defineComponent({
  components: {
    MarketingModal,
    LeftImage,
  },
  setup() {
    const loaded = ref(false);
    const unhandledrejectionHandler = event => {
      if (bugsnagClient) {
        bugsnagClient.notify(event);
      }
    };

    window.addEventListener('unhandledrejection', unhandledrejectionHandler);

    onMounted(async () => {
      await loadLanguageAsync(userLanguage());
      loaded.value = true;
    });

    onBeforeUnmount(() => {
      window.removeEventListener('unhandledrejection', unhandledrejectionHandler);
    });

    return {
      loaded,
    };
  },
});
